import { createAsyncThunk } from "@reduxjs/toolkit";
import { axiosApiInstance } from "@/helper/axios";
import { API_PORTAL_URL } from "@/lib/config";
import { ErrorToast, SuccessToast } from "@/components/toast/Toasts";
import { IBlog } from "./blogModel";

export const getAllBlog = createAsyncThunk("Blog/FindAllBlog", async () => {
  try {
    const response = await axiosApiInstance.post(
      `${API_PORTAL_URL}/Blog/FindAllBlog`,
      { Title: "" },
    );
    return response.data?.Data.map((item: any) => ({
      ...item,
      IsActive: item.IsActive || false,
    }));
  } catch (error: any) {
    console.error("Error Fetching Blog:", error);
    return Promise.reject({
      message: error?.response?.data?.Details || "Something went wrong",
    });
  }
});

export const createBlog = createAsyncThunk(
  "Blog/InsertBlog",
  async (blogData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_PORTAL_URL}/Blog/InsertBlog`,
        blogData,
      );
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error creating Blog:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const updateBlog = createAsyncThunk(
  "Blog/UpdateBlog",
  async (blogData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_PORTAL_URL}/Blog/UpdateBlog`,
        blogData,
      );
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error updating Blog:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const getBlogByID = createAsyncThunk(
  "Blog/FindByIDBlog",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_PORTAL_URL}/Blog/FindByIDBlog`,
        { ID },
      );
      const result = response.data?.Data as any;
      return {
        ...result,
        IsActive: result.IsActive || false,
      } as IBlog;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error fetching Blog:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const ActiveInactiveBlog = createAsyncThunk(
  "Blog/ActiveInActiveBlog",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_PORTAL_URL}/Blog/ActiveInActiveBlog`,
        formData,
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error active-inactive Blog:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const deleteBlog = createAsyncThunk(
  "Blog/DeleteBlog",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_PORTAL_URL}/Blog/DeleteBlog`,
        { ID },
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting Blog:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const BlogImageUpload = createAsyncThunk(
  "Blog/BlogImageUpdate",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_PORTAL_URL}/Blog/BlogImageUpdate`,
        formData,
        {
          headers: { "content-type": "multipart/form-data" },
        },
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error upload Blog Image:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export async function getAllActiveBlogs() {
  try {
    const response = await fetch(`${API_PORTAL_URL}/Blog/FindAllActiveBlog`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "Cache-Control": "no-cache",
      },
      cache: "no-store",
    });
    const data = await response.json();
    return data?.Data;
  } catch (error) {
    console.error("Error fetching all active blogs:", error);
    return [];
  }
}

export async function getBlogData(url: string) {
  try {
    const response = await fetch(`${API_PORTAL_URL}/Blog/BlogFindByURL`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ BlogURL: url }),
      cache: "no-store",
    });
    const data = await response.json();
    return data?.Data;
  } catch (error) {
    console.error(`Error fetching blog data for ${url}:`, error);
    return null;
  }
}
